module.exports = __webpack_public_path__ + "img/restaurant.45b60581.jpg";